import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ATTRACTIONS } from "../mock";

const NearbyWonders = () => {
  const scroller = useRef(null);

  const scrollBy = (dir) => {
    if (!scroller.current) return;
    const amount = scroller.current.clientWidth * 0.8;
    scroller.current.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <section id="attractions" className="py-20 md:py-28 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center text-neutral-900 mb-12">
          Discover Nearby Wonders
        </h2>

        <div className="relative">
          <button
            onClick={() => scrollBy(-1)}
            className="absolute -left-3 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white shadow-lg flex items-center justify-center text-neutral-700 hover:text-[#17a89b] transition-colors"
            aria-label="previous"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          <div
            ref={scroller}
            className="flex gap-5 overflow-x-auto scroll-smooth pb-4 snap-x hide-scrollbar"
          >
            {ATTRACTIONS.map((a) => (
              <div
                key={a.title}
                className="group relative shrink-0 w-[260px] sm:w-[300px] h-[340px] rounded-lg overflow-hidden snap-start shadow-md"
              >
                <img
                  src={a.img}
                  alt={a.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/40" />
                <div className="absolute inset-0 p-6 flex flex-col items-center text-center justify-start pt-7">
                  <h3 className="text-white text-2xl font-bold drop-shadow mb-2">
                    {a.title}
                  </h3>
                  <p className="text-white/90 text-sm leading-relaxed">{a.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => scrollBy(1)}
            className="absolute -right-3 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white shadow-lg flex items-center justify-center text-neutral-700 hover:text-[#17a89b] transition-colors"
            aria-label="next"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default NearbyWonders;
